// Home page — 'Why choose A4 Express' cards.

export const FEATURES = [
  { i: "coverage", t: "Nationwide coverage", d: "One transport partner for the whole of the UK and Ireland, including cross-channel and cross-border movements." },
  { i: "reliable", t: "Reliable deliveries", d: "Planned collection and delivery windows, proactive updates and full proof of delivery on every consignment." },
  { i: "fleet", t: "Modern fleet", d: "A young, well-maintained fleet from 3.5 tonne vans to 44 tonne articulated units, ready when you need it." },
  { i: "drivers", t: "Experienced drivers", d: "Fully licensed, CPC-qualified drivers who represent your business professionally at every delivery point." },
  { i: "logistics", t: "Business logistics", d: "Scheduled runs, contract distribution and overflow capacity that flexes with your demand." },
  { i: "leaf", t: "Sustainable transport", d: "Electric 3.5 tonne vans in service for urban and low-emission zone work, with the fleet expanding each year." },
];

export default FEATURES;
